(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-shortcuts"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('collection-shortcuts')) {
    window.customElements.define('collection-shortcuts', class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.collection-shortcuts__list');
        if (!this.list) return;
        this.list.addEventListener('scrollend', () => this.completeScrollToEnd());
        requestAnimationFrame(() => {
          this.centerCurrentItem();
          this.lastScrollLeft = this.list.scrollLeft;
        });
      }

      centerCurrentItem() {
        const current = this.list.querySelector('[aria-current="page"]')?.closest('.collection-shortcuts__item');
        if (!current) return;
        const listLeft = this.list.getBoundingClientRect().left;
        const itemLeft = current.getBoundingClientRect().left;
        this.list.scrollLeft += itemLeft - listLeft - (this.list.clientWidth - current.offsetWidth) / 2;
      }

      completeScrollToEnd() {
        const themeEdgeThreshold = 125;
        const movedForward = this.list.scrollLeft > this.lastScrollLeft;
        const remaining = this.list.scrollWidth - this.list.clientWidth - this.list.scrollLeft;
        this.lastScrollLeft = this.list.scrollLeft;
        if (movedForward && remaining > 1 && remaining <= themeEdgeThreshold) {
          this.list.scrollTo({ left: this.list.scrollWidth, behavior: 'smooth' });
          return;
        }
        this.querySelector('[is="prev-button"]').disabled = this.list.scrollLeft <= 1;
        this.querySelector('[is="next-button"]').disabled = remaining <= 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
